import { render, staticRenderFns } from "./cg-event-type.vue?vue&type=template&id=69f81117&scoped=true"
import script from "./cg-event-type.vue?vue&type=script&lang=js"
export * from "./cg-event-type.vue?vue&type=script&lang=js"
import style0 from "./cg-event-type.vue?vue&type=style&index=0&id=69f81117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f81117",
  null
  
)

export default component.exports